import {
    APP_PREFIX_PATH,
    RESELLER_PREFIX_PATH,
    ADVERTISER_PREFIX_PATH,
    CUSTOMER_PREFIX_PATH,
    AUTH_PREFIX_PATH,
    FORGET_PASSWORD_PREFIX_PATH,
    RESET_PASSWORD_PREFIX_PATH,
    REVIEW_SIGN_UP_PREFIX_PATH,
    SIGN_UP_PREFIX_PATH, APPLICATION_LOGIN_PREFIX_PATH, RESPONDER_PREFIX_PATH
} from "configs/AppConfig";
import React from "react";
import * as navKeys from "../constants/PermissionConstant";
import {ADVERTISER_ESIM, ADVERTISER_WALLET, RESPONDER_ESIM, RESPONDER_RIDE, RESPONDER_VEHICLE, RESPONDER_WALLET} from "../constants/PermissionConstant";

export const publicRoutes = [
    {
        key: "login",
        path: `${AUTH_PREFIX_PATH}`,
        component: React.lazy(() =>
            import("views/public-views/login")
        ),
    },
    {
        key: "sign-up",
        path: `${SIGN_UP_PREFIX_PATH}`,
        component: React.lazy(() =>
            import("views/public-views/sign-up")
        ),
    },
    {
        key: "review-sign-up",
        path: `${REVIEW_SIGN_UP_PREFIX_PATH}/:id/`,
        component: React.lazy(() =>
            import("views/public-views/sign-up/ReviewSignUp")
        ),
    },
    {
        key: "forget-password",
        path: `${FORGET_PASSWORD_PREFIX_PATH}`,
        component: React.lazy(() =>
            import("views/public-views/forget-password")
        ),
    },
    {
        key: "reset-password",
        path: `${RESET_PASSWORD_PREFIX_PATH}/:id`,
        component: React.lazy(() =>
            import("views/public-views/reset-password")
        ),
    },
    {
        key: "app-login",
        path: `${APPLICATION_LOGIN_PREFIX_PATH}/:id`,
        component: React.lazy(() =>
            import("views/public-views/app-login")
        ),
    },
];

export const backofficeProtectedRoutes = [
    {
        key: navKeys.ADMIN_DASHBOARD,
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import("views/app-views/backoffice/dashboard")),
    },
    {
        key: navKeys.SOS_REQUEST,
        path: `${APP_PREFIX_PATH}/sos-request/calls`,
        component: React.lazy(() => import("views/app-views/backoffice/sos-request/calls")),
    },
    {
        key: navKeys.SOS_REGISTRATION_REQUEST,
        path: `${APP_PREFIX_PATH}/sos-request/registrations`,
        component: React.lazy(() => import("views/app-views/backoffice/sos-request/registrations")),
    },
    {
        key: navKeys.SOS_RESPONDER_REQUEST,
        path: `${APP_PREFIX_PATH}/sos-request/responders`,
        component: React.lazy(() => import("views/app-views/backoffice/sos-request/responders")),
    },
    {
        key: navKeys.CUSTOMERS,
        path: `${APP_PREFIX_PATH}/customers`,
        component: React.lazy(() => import("views/app-views/backoffice/users/customers")),
    },
    {
        key: "customerView",
        path: `${APP_PREFIX_PATH}/customers/view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/users/customers/view/index")),
    },
    {
        key: navKeys.TICKET_VIEW,
        path: `${APP_PREFIX_PATH}/customer-ticket-view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/users/customers/view/tickets/ticket-view/index")),
    },
    {
        key: navKeys.RESELLERS,
        path: `${APP_PREFIX_PATH}/resellers`,
        component: React.lazy(() => import("views/app-views/backoffice/users/resellers")),
    },
    {
        key: navKeys.RESELLERS,
        path: `${APP_PREFIX_PATH}/resellers/view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/users/resellers/view")),
    },
    {
        key: navKeys.ADVERTISERS,
        path: `${APP_PREFIX_PATH}/advertisers`,
        component: React.lazy(() => import("views/app-views/backoffice/users/advertisers")),
    },
    {
        key: navKeys.ADVERTISERS,
        path: `${APP_PREFIX_PATH}/advertisers/view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/users/advertisers/view")),
    },
    {
        key: navKeys.RESPONDERS,
        path: `${APP_PREFIX_PATH}/responders`,
        component: React.lazy(() => import("views/app-views/backoffice/users/responders")),
    },
    {
        key: navKeys.RESPONDERS,
        path: `${APP_PREFIX_PATH}/responders/view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/users/responders/view")),
    },
    {
        key: navKeys.WALLET_TRANSACTIONS,
        path: `${APP_PREFIX_PATH}/wallet-payments`,
        component: React.lazy(() => import("views/app-views/backoffice/transactions/wallet-payments")),
    },
    {
        key: navKeys.SOS_TRANSACTIONS,
        path: `${APP_PREFIX_PATH}/sos-payments`,
        component: React.lazy(() => import("views/app-views/backoffice/transactions/sos-payments")),
    },
    {
        key: navKeys.ESIM_TRANSACTIONS,
        path: `${APP_PREFIX_PATH}/esim-payments`,
        component: React.lazy(() => import("views/app-views/backoffice/transactions/esim-payments")),
    },
    {
        key: navKeys.ACCOUNT_SETTINGS,
        path: `${APP_PREFIX_PATH}/account-settings/*`,
        component: React.lazy(() => import("views/app-views/backoffice/system/staff-roles/account-settings")),
    },
    {
        key: navKeys.STAFF,
        path: `${APP_PREFIX_PATH}/staff`,
        component: React.lazy(() => import("views/app-views/backoffice/system/staff-roles/staff")),
    },
    {
        key: navKeys.ROLES,
        path: `${APP_PREFIX_PATH}/roles`,
        component: React.lazy(() => import("views/app-views/backoffice/system/staff-roles/roles")),
    },
    {
        key: navKeys.TICKET,
        path: `${APP_PREFIX_PATH}/tickets`,
        component: React.lazy(() => import("views/app-views/backoffice/system/tickets")),
    },
    {
        key: navKeys.TICKET_VIEW,
        path: `${APP_PREFIX_PATH}/ticket-view/:id/`,
        component: React.lazy(() => import("views/app-views/backoffice/system/tickets/view")),
    },
    {
        key: navKeys.CLIENT_SETTINGS,
        path: `${APP_PREFIX_PATH}/client-settings`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/client-settings")),
    },
    {
        key: navKeys.SYSTEM_COUNTRIES,
        path: `${APP_PREFIX_PATH}/system-countries`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/system-countries")),
    },
    {
        key: navKeys.BUNDLES,
        path: `${APP_PREFIX_PATH}/bundles`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/bundles")),
    },
    {
        key: navKeys.LIVE_TV,
        path: `${APP_PREFIX_PATH}/live-tv`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/live-tv")),
    },
    {
        key: navKeys.LIVE_RADIO,
        path: `${APP_PREFIX_PATH}/live-radio`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/live-radio")),
    },
    {
        key: navKeys.ADDRESS_COUNTRIES,
        path: `${APP_PREFIX_PATH}/address-countries`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/address-countries")),
    },
    {
        key: navKeys.ESIM_NUMBERS,
        path: `${APP_PREFIX_PATH}/esim-numbers`,
        component: React.lazy(() => import("views/app-views/backoffice/system/settings/esim-numbers")),
    },
    {
        key: navKeys.VOIP_SWITCH_SETTINGS,
        path: `${APP_PREFIX_PATH}/voIP-switch`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/voip-switch")),
    },
    {
        key: navKeys.FLEX_PAY_SETTINGS,
        path: `${APP_PREFIX_PATH}/flexpay`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/flexpay")),
    },
    {
        key: navKeys.DT_ONE_SETTINGS,
        path: `${APP_PREFIX_PATH}/dtone`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/dtone")),
    },
    {
        key: navKeys.THUNES_SETTINGS,
        path: `${APP_PREFIX_PATH}/thunes`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/thunes")),
    },
    {
        key: navKeys.OTT_VOUCHER_SETTINGS,
        path: `${APP_PREFIX_PATH}/ott-voucher`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/ott-voucher")),
    },
    {
        key: navKeys.OTT_DENOMINATIONS,
        path: `${APP_PREFIX_PATH}/ott-denominations`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/ott-denominations")),
    },
    {
        key: navKeys.SOS_SETTINGS,
        path: `${APP_PREFIX_PATH}/parsos`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/parsos")),
    },
    {
        key: navKeys.SILICON_SETTINGS,
        path: `${APP_PREFIX_PATH}/silicon`,
        component: React.lazy(() => import("views/app-views/backoffice/system/third-party/silicon")),
    },
    {
        key: navKeys.ACTIVITY_LOGS,
        path: `${APP_PREFIX_PATH}/activity-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/activity-logs")),
    },
    {
        key: navKeys.SOS_LOGS,
        path: `${APP_PREFIX_PATH}/parsos-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/parsos-logs")),
    },
    {
        key: navKeys.DTONE_LOGS,
        path: `${APP_PREFIX_PATH}/dtone-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/dtone-logs")),
    },
    {
        key: navKeys.FLEXPAY_LOGS,
        path: `${APP_PREFIX_PATH}/flexpay-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/flexpay-logs")),
    },
    {
        key: navKeys.OTT_VOUCHER_LOGS,
        path: `${APP_PREFIX_PATH}/ottvouchers-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/ottvouchers-logs")),
    },
    {
        key: navKeys.SILICON_LOGS,
        path: `${APP_PREFIX_PATH}/silicon-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/silicon-logs")),
    },
    {
        key: navKeys.THUNES_LOGS,
        path: `${APP_PREFIX_PATH}/thunes-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/thunes-logs")),
    },
    {
        key: navKeys.VOIP_SWITCH_LOGS,
        path: `${APP_PREFIX_PATH}/voipswitch-logs`,
        component: React.lazy(() => import("views/app-views/backoffice/system/system-logs/voipswitch-logs")),
    },
];

export const resellerProtectedRoutes = [
    {
        key: navKeys.DASHBOARD,
        path: `${RESELLER_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import("views/app-views/reseller/dashboard")),
    },
];

export const advertiserProtectedRoutes = [
    {
        key: navKeys.DASHBOARD,
        path: `${ADVERTISER_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import("views/app-views/advertiser/dashboard")),
    },
];

export const responderProtectedRoutes = [
    {
        key: navKeys.DASHBOARD,
        path: `${RESPONDER_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import("views/app-views/responder/dashboard")),
    },
    {
        key: navKeys.RESPONDER_WALLET,
        path: `${RESPONDER_PREFIX_PATH}/wallet`,
        component: React.lazy(() => import("views/app-views/responder/wallet")),
    },
    {
        key: navKeys.RESPONDER_ESIM,
        path: `${RESPONDER_PREFIX_PATH}/esim`,
        component: React.lazy(() => import("views/app-views/responder/esim")),
    },
    {
        key: navKeys.RESPONDER_RIDE,
        path: `${RESPONDER_PREFIX_PATH}/ride`,
        component: React.lazy(() => import("views/app-views/responder/ride")),
    },
    {
        key: navKeys.RESPONDER_VEHICLE,
        path: `${RESPONDER_PREFIX_PATH}/vehicle`,
        component: React.lazy(() => import("views/app-views/responder/vehicle")),
    },
];

export const customerProtectedRoutes = [
    {
        key: navKeys.DASHBOARD,
        path: `${CUSTOMER_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import("views/app-views/customer/dashboard")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/wallet`,
        component: React.lazy(() => import("views/app-views/customer/wallet")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/esim`,
        component: React.lazy(() => import("views/app-views/customer/esim")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/sos-calls`,
        component: React.lazy(() => import("views/app-views/customer/sos-calls")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/referral`,
        component: React.lazy(() => import("views/app-views/customer/referral")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/utilities`,
        component: React.lazy(() => import("views/app-views/customer/utilities")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/campaign`,
        component: React.lazy(() => import("views/app-views/customer/campaign")),
    },
    {
        key: navKeys.CUSTOMER_WALLET,
        path: `${CUSTOMER_PREFIX_PATH}/account-settings`,
        component: React.lazy(() => import("views/app-views/customer/account-settings")),
    },
];
